import { G } from '@/_common';

export const user_stores = {
    data: {
        wishlist: []
    },
    api: {
        langs:                              '/{lang}/langs',
        translations:                       '/{lang}/translations',
        system_settings:                    '/{lang}/system/{key}',

        menus:                              '/{lang}/menus',
        // menu_by_id:                         '/{lang}/menu/{menu_id}',

        banners:                            '/{lang}/banners',

        // category_by_id:                     '/{lang}/category/{category_id}',
        // categories_parent:                  '/{lang}/parent_categories',
        // categories_with_children:           '/{lang}/categories_children',

        // author:                             '/{lang}/author/lazy',
        // author_update:                      '/{lang}/author/{author_id}',
        // // authors_by_page:                    '/{lang}/authors_paging/{author_id}/{page}/{perpage}/{sortfield}/{sortorder}/{filters}?search_text={search_text}',
        // authors_by_page:                    '/{lang}/authors_paging/{page}/{perpage}',
        // authors_post_by_page:               '/{lang}/authors_post_paging/{author_id}/{page}/{perpage}?search_text={search_text}',

        // posts:                              '/{lang}/posts/lazy',
        // posts_main:                         '/{lang}/posts/main',
        // post_by_id:                         '/{lang}/post/{id}',
        // // post_by_page:                       '/{lang}/post_paging/{category_id}/{author_id}/{page}/{perpage}/{sortfield}/{sortorder}/{filters}?search_text={search_text}',
        // post_by_page:                       '/{lang}/post_paging/{category_id}/{page}/{perpage}?search_text={search_text}',
        // post_similar:                       '/{lang}/post_similar/{post_id}/{category_id}',

        videos:                             '/{lang}/videos/lazy',
        // tv_by_page:                         '/{lang}/tv_paging/{category_id}/{author_id}/{page}/{perpage}/{sortfield}/{sortorder}/{filters}?search_text={search_text}',
        videos_by_page:                     '/{lang}/videos/{page}/{perpage}',

        social_network:                     '{lang}/social_network',
        contact:                            '{lang}/contact',
    },

    getters: {
        // ---------------------------------------------------------------------------------------------
        getTranslations: (state) => () => {
            return state.api.translations.replace('{lang}', state.lang);
        },

		// initializeWishlist({ commit }) {
        //     const wishlistFromStorage = localStorage.getItem('wishlist');
        //     if (wishlistFromStorage) {
        //         commit('SET_WISHLIST', JSON.parse(wishlistFromStorage));
        //     }
        // },
        // addToWishlist({ commit }, product) {
        //     commit('ADD_TO_WISHLIST', product);
        // },
        // removeFromWishlist({ commit }, productId) {
        //     commit('REMOVE_FROM_WISHLIST', productId);
        // },
		// fetchMenuList({ commit }) {
        //     const apiURL = `${G.ajaxBaseUrl}/api/api.php?param=navigator`;
        //     fetch(apiURL)
        //         .then(response => response.json())
        //         .then(data => {
        //             commit('SET_MENU_LIST', data);
        //         })
        //         .catch(error => console.error('Error fetching menu list:', error));
        // },
		// fetchFooterAbout({ commit }) {
        //     const apiURL = `${G.ajaxBaseUrl}/api/api.php?param=about_footer`;
        //     fetch(apiURL)
        //         .then(response => response.json())
        //         .then(data => {
        //             commit('SET_FOOTER_ABOUT', data);
        //         })
        //         .catch(error => console.error('Error fetching menu list:', error));
        // },
		// fetchContactData({ commit }) {
        //     const apiURL = `${G.ajaxBaseUrl}/api/api.php?param=contact`;
        //     fetch(apiURL)
        //         .then(response => response.json())
        //         .then(data => {
        //             commit('SET_CONTACT_DATA', data);
        //         })
        //         .catch(error => console.error('Error fetching menu list:', error));
        // },

        addToWishlist: (state) => (product) => {
            if (!state.data.wishlist.some(p => p.id === product.id)) {
                state.data.wishlist.push(product);
                G.setClientData('wishlist', JSON.stringify(state.data.wishlist));
            }
		},
        removeFromWishlist: (state) => (productId) => {
            state.data.wishlist = state.data.wishlist.filter(p => p.id !== productId);
            G.setClientData('wishlist', JSON.stringify(state.data.wishlist));
        },

        // ---------------------------------------------------------------------------------------------

        getSystemSettings: (state) => (key = 'system') => {
            return state.api.system_settings.replace('{lang}', state.lang).replace('{key}', key);
        },
        getLangs: (state) => () => {
            return state.api.langs.replace('{lang}', state.lang);
        },
        getMenus: (state) => () => {
            return state.api.menus.replace('{lang}', state.lang);
        },
        // getMenuById: (state) => (menu_id) => {
		// 	return state.api.menu_by_id.replace('{lang}', state.lang).replace('{menu_id}', menu_id);
		// },
		getBanners: (state) => () => {
			return state.api.banners.replace('{lang}', state.lang);
		},

		// getCategoryById: (state) => (category_id) => {
		// 	return state.api.category_by_id.replace('{lang}', state.lang).replace('{category_id}', category_id);
		// },
		// getCategories: (state) => () => {
		// 	return state.api.categories_parent.replace('{lang}', state.lang);
		// },
		// getCategoriesWithChildren: (state) => () => {
		// 	return state.api.categories_with_children.replace('{lang}', state.lang);
		// },

        // getPosts: (state) => () => {
        //     return state.api.posts.replace('{lang}', state.lang);
        // },
        // getPostsMain: (state) => () => {
        //     return state.api.posts_main.replace('{lang}', state.lang);
        // },
        // getPostById: (state) => (id) => {
        //     if( id === undefined ){
        //         id = 0;
        //     }
        //     return state.api.post_by_id.replace('{lang}', state.lang).replace('{id}', id);
        // },
        // getPostPaging: (state) => (data) => {
        //     let s = state.api.post_by_page.replace('{lang}', state.lang);
        //     for( let a in data ){
        //         s = s.replace(`{${a}}`, data[a]);
        //     }
        //     return s;
        // },

        // getAuthor: (state) => () => {
        //     return state.api.author.replace('{lang}', state.lang);
        // },
        // getAuthorUpdate: (state) => (author_id) => {
        //     return state.api.author_update.replace('{lang}', state.lang).replace('{author_id}', author_id);
        // },
        // getAuthorsPaging: (state) => (data) => {
        //     let s = state.api.authors_by_page.replace('{lang}', state.lang);
        //     for( let a in data ){
        //         s = s.replace(`{${a}}`, data[a]);
        //     }
        //     return s;
        // },
        // getAuthorsPostPaging: (state) => (data) => {
        //     let s = state.api.authors_post_by_page.replace('{lang}', state.lang);
        //     for( let a in data ){
        //         s = s.replace(`{${a}}`, data[a]);
        //     }
        //     return s;
        // },

        getVideos: (state) => () => {
            return state.api.videos.replace('{lang}', state.lang);
        },
        getVideosPaging: (state) => (data) => {
            let s = state.api.videos_by_page.replace('{lang}', state.lang);
            for( let a in data ){
                s = s.replace(`{${a}}`, data[a]);
            }
            return s;
        },

		getSocialNetwork: (state) => () => {
			return state.api.social_network.replace('{lang}', state.lang);
		},

		getContactData: (state) => () => {
			return state.api.contact.replace('{lang}', state.lang);
		},

        // getProductById: (state) => (product_id) => {
        //     if( product_id === undefined ){
        //         product_id = 0;
        //     }
        //     return state.api.product_by_id.replace('{lang}', state.lang).replace('{product_id}', product_id);
        // },
        // getProductsByCategory: (state) => (category_id) => {
        //     if( category_id === undefined ){
        //         category_id = 0;
        //     }
        //     return state.api.products_by_category.replace('{lang}', state.lang).replace('{category_id}', category_id);
        // },
        // getProductsByName: (state) => (name) => {
        //     return state.api.products_by_category.replace('{lang}', state.lang).replace('{name}', name);
        // },
        // // getProductsPaging: (state) => (category_id) => {
        // getProductsPaging: (state) => (data) => {
        //     // if( category_id === undefined ){
        //     //     category_id = 0;
        //     // }
        //     let s = state.api.products_by_page.replace('{lang}', state.lang);
        //     for( let a in data ){
        //         s = s.replace(`{${a}}`, data[a]);
        //     }
        //     // for( let a in data.query ){
        //     //     s = s.replace(`{${a}}`, data.query[a]);
        //     // }
        //     return s;
        // },
        // getProductsSimilarByCategory: (state) => (product_id, category_id) => {
        //     if( category_id === undefined ){
        //         category_id = 0;
        //     }
        //     if( product_id === undefined ){
        //         product_id = 0;
        //     }
        //     return state.api.products_similar.replace('{lang}', state.lang).replace('{product_id}', product_id).replace('{category_id}', category_id);
        // },
    },
    // actions: {
    //     //
    // }

};
